import styled from 'styled-components';
import Parent from './style';

const Wrapper = styled(Parent.Wrapper)`
${({ theme }) => `
form {
    padding: 0 2%;
}
.creditCardWrapper {
  display: none;
}
.buttonSection {
  display: flex;
  justify-content: center;
  .companyInfoSubmit{
    order: 2;
    margin-left: 1%;
  }
}
.companyForm .checkboxesCompany .agreeTerms {
  flex: 0 0 47%;
  .normalCheckbox span {
    padding-left: 12px;
  }
}
.cycleruleSection .basic-multi-select .select__control {
    height: auto !important;
    .select__value-container {
     height: auto !important;
    }
    .select__multi-value {
       position: relative;
       background: #fff;
      .select__multi-value__label{
       padding-left: 13px;
      }
      .select__multi-value__remove {
       color: #999;
       position: absolute;
       top: 3px;
       padding-left: 0;
       padding-right: 0;
      }
    }
 }
 #creditCardUpdate,
 #subCancelButton {
     padding: 0 10px !important;
 }
`}
`;
const leftSection = styled(Parent.leftSection)`
${({ theme }) => `

`}
`;
const rightSection = styled(Parent.rightSection)`

`;
const TextWrapper = styled(Parent.TextWrapper)`
`;

const FieldsWrapper = styled(Parent.FieldsWrapper)`

`;
const wrapperSection = styled(Parent.wrapperSection)`

`;

const InsuranceCompanyWrapper= styled(Parent.InsuraceCompanyWrapper)`
`;
const Styled = {
  Wrapper,
  TextWrapper,
  FieldsWrapper,
  leftSection,
  rightSection,
  wrapperSection,
  InsuranceCompanyWrapper
};

export default Styled;
